import request from '@/utils/request'
import qs from 'qs'
import {
	getCookie
} from '@/utils/cookiejs'

// fba下草稿订单
export function CreateFBAOrder(data) {
	return request({
		url: `/api/shipping/FbaOrder`,
		method: 'post',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}
// fba订单详情
export function GetFbaOrderDetail(orderNo) {
	return request({
		url: `/api/shipping/FbaOrder/${orderNo}`,
		method: 'get',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}
// 空运下草稿订单
export function CreateAirOrder(data) {
	return request({
		url: `/api/shipping/AirOrder/QueryPriceOrder`,
		method: 'post',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}
// 空运订单详情
export function GetAirOrderDetail(orderNo) {
	return request({
		url: `/api/shipping/AirOrder/Detail/${orderNo}`,
		method: 'get',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}
// 快递下草稿订单
export function CreateExpOrder(data) {
	return request({
		url: `/api/shipping/ExpOrder`,
		method: 'post',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}
// 快递订单详情
export function GetExpOrderDetail(orderNo) {
	return request({
		url: `/api/shipping/ExpOrder/${orderNo}`,
		method: 'get',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}
// 查询公司账单信息
export function GetCompanyBilling(orderNo) {
	return request({
		url: `/api/shipping/CompanyBilling/GetByOrderNo/${orderNo}`,
		method: 'get',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

// 新增公司账单信息
export function CreateCompanyBilling(data) {
	return request({
		url: `/api/shipping/CompanyBilling`,
		method: 'post',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

// 编辑公司账单信息
export function UpdateCompanyBilling(data) {
	return request({
		url: `/api/shipping/CompanyBilling`,
		method: 'put',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

// 新建订单地址
export function CreateOrderAddress(data) {
	return request({
		url: `/api/shipping/Address`,
		method: 'post',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

// 编辑订单地址
export function UpdateOrderAddress(data) {
	return request({
		url: `/api/shipping/Address`,
		method: 'put',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

// 获取订单地址
export function GetOrderAddress(data) {
	return request({
		url: `/api/shipping/Address/GetInfo`,
		method: 'get',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

// 保存订单商品
export function SaveOrderCommodities(data) {
	return request({
		url: `/api/wms/Operate/order/Commodities`,
		method: 'post',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

// 获取订单商品
export function GetOrderCommodities(orderNo) {
	return request({
		url: `/api/wms/Operate/order/Commodities/${orderNo}`,
		method: 'get',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

// 上传订单附件
export function UploadOrderAttach(data) {
	return request({
		url: `/api/wms/Operate/order/Attach`,
		method: 'post',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

// 获取订单附件
export function GetOrderAttach(orderNo) {
	return request({
		url: `/api/wms/Operate/order/Attach/${orderNo}`,
		method: 'get',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

// 获取订单未完成模块
export function CheckOrderComplete(orderNo) {
	return request({
		url: `/api/wms/Operate/order/Check/${orderNo}`,
		method: 'get',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

// 获取订单详细完成情况
export function CheckOrderCompleteDetail(orderNo) {
	return request({
		url: `/api/wms/Operate/order/CheckDetail/${orderNo}`,
		method: 'get',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

// 修改fba订单为已预报
export function UpdateFBAConfirm(orderNo) {
	return request({
		url: `/api/shipping/FbaOrder/UpdateConfirm/${orderNo}`,
		method: 'put',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

// 修改fba订单为已预报
export function CancelFBAOrder(data) {
	return request({
		url: `/api/wms/Operate/FBA/Cancel`,
		method: 'post',
		data: qs.stringify(data),
		headers: {
			'Authorization': getCookie('token')
		}
	})
}
//修改空运订单为已预报
export function UpdateAirConfirm(orderNo) {
	return request({
		url: `/api/shipping/AirOrder/UpdateConfirm/${orderNo}`,
		method: 'put',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}
//取消空运订单
export function CancelAirOrder(data) {
	return request({
		url: `/api/wms/Operate/Air/Cancel`,
		method: 'post',
		data: qs.stringify(data),
		headers: {
			'Authorization': getCookie('token')
		}
	})
}
// 修改快递订单为已预报
export function UpdateExpConfirm(orderNo) {
	return request({
		url: `/api/shipping/ExpOrder/UpdateConfirm/${orderNo}`,
		method: 'put',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}
// 取消快递订单
export function CancelExpOrder(data) {
	return request({
		url: `/api/wms/Operate/Exp/Cancel`,
		method: 'post',
		data: qs.stringify(data),
		headers: {
			'Authorization': getCookie('token')
		}
	})
}
// 海运下草稿订单
export function CreateSeaOrder(data) {
	return request({
		url: `/api/shipping/SeaOrder/QueryPriceOrder`,
		method: 'post',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}
// 海运订单详情
export function GetSeaOrderDetail(orderNo) {
	return request({
		url: `/api/shipping/SeaOrder/${orderNo}`,
		method: 'get',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}
//修改海运订单为已预报
export function UpdateSeaConfirm(orderNo) {
	return request({
		url: `/api/shipping/SeaOrder/UpdateConfirm/${orderNo}`,
		method: 'put',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}
//取消海运订单
export function CancelSeaOrder(data) {
	return request({
		url: `/api/wms/Operate/Sea/Cancel`,
		method: 'post',
		data: qs.stringify(data),
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//确认支付方式
export function PayConfirm(data) {
	return request({
		url: `/api/fin/OrderPay/ConfirmPayment`,
		method: 'post',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//获取订单应付账单
export function GetOrderBill(orderNo) {
	return request({
		url: `/api/fin/FinancialCosts/GetOrderBill/${orderNo}`,
		method: 'get',
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//修改订单参考号
export function UpdateRefNo(data) {
	return request({
		url: `/api/shipping/Order/UpdateRefNo`,
		method: 'put',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//修改订单参考号
export function UpdateGoodsReadyTime(data) {
	return request({
		url: `/api/shipping/Order/UpdateGoodsReadyTime`,
		method: 'put',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//获取订单轨迹
export function GetOrderTrack(data) {
	return request({
		url: `/api/wms/Track/GetList`,
		method: 'get',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}

//导出订单详情
export function ExportOrderDetail(data) {
	return request({
		url: `/api/shipping/Order/ExportOrderDetail`,
		method: 'get',
		data: data,
		headers: {
			'Authorization': getCookie('token')
		}
	})
}